import { request } from '@/shared/api/request'

export const getXml = (data) => request({ url: 'proactive/saveReqAndGetXml', method: 'POST', data })
